module.exports = __webpack_public_path__ + "img/SharingDocuments02.65436c61.svg";